import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AppHeader } from "@/components/AppHeader";
import { Phone, EnvelopeSimple, ArrowLeft } from "@phosphor-icons/react";

export default function Contact() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-background">
      {user ? (
        <AppHeader />
      ) : (
        <header className="sticky top-0 z-50 border-b border-white/10 bg-zinc-950/60 backdrop-blur-xl">
          <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
            <Link to="/" className="flex items-center gap-2">
              <span className="font-display text-xl tracking-tighter">DAFARGOS</span>
              <span className="overline text-primary mt-1">Holdings LLC</span>
            </Link>
            <Link to="/" className="text-sm text-muted-foreground hover:text-foreground inline-flex items-center gap-2">
              <ArrowLeft size={16} /> Home
            </Link>
          </div>
        </header>
      )}

      <main className="max-w-3xl mx-auto px-6 py-20">
        <div className="overline text-primary mb-3">Get in touch</div>
        <h1 className="font-serif text-4xl md:text-5xl font-medium tracking-tight mb-4">Contact Us</h1>
        <p className="text-muted-foreground mb-12 max-w-xl">
          Have a question about our services or your onboarding? Our team is here to help.
        </p>

        <div className="grid sm:grid-cols-2 gap-6">
          <a
            href="tel:+18773274605"
            data-testid="contact-phone"
            className="group rounded-xl border border-white/10 bg-zinc-900/50 p-8 hover:border-primary/40 transition-colors"
          >
            <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-6">
              <Phone size={24} weight="duotone" className="text-primary" />
            </div>
            <div className="text-sm text-muted-foreground mb-1">Call us</div>
            <div className="font-display text-xl tracking-tight group-hover:text-primary transition-colors">
              1-877-327-4605
            </div>
          </a>

          <a
            href="mailto:admin@dafargosholdings.com"
            data-testid="contact-email"
            className="group rounded-xl border border-white/10 bg-zinc-900/50 p-8 hover:border-primary/40 transition-colors"
          >
            <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center mb-6">
              <EnvelopeSimple size={24} weight="duotone" className="text-primary" />
            </div>
            <div className="text-sm text-muted-foreground mb-1">Email us</div>
            <div className="font-display text-xl tracking-tight group-hover:text-primary transition-colors break-all">
              admin@dafargosholdings.com
            </div>
          </a>
        </div>
      </main>
    </div>
  );
}
